/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type DetailsContact_deliverable$ref: FragmentReference;
declare export opaque type DetailsContact_deliverable$fragmentType: DetailsContact_deliverable$ref;
export type DetailsContact_deliverable = {|
  +assignedStaff: ?{|
    +fullName: ?string,
    +representativeImageUrl: ?string,
    +organization: {|
      +representativeImageUrl: ?string,
      +name: string,
      +country: ?{|
        +name: ?string
      |},
    |},
  |},
  +$refType: DetailsContact_deliverable$ref,
|};
export type DetailsContact_deliverable$data = DetailsContact_deliverable;
export type DetailsContact_deliverable$key = {
  +$data?: DetailsContact_deliverable$data,
  +$fragmentRefs: DetailsContact_deliverable$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "representativeImageUrl",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "DetailsContact_deliverable",
  "type": "DeliverableNode",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "assignedStaff",
      "storageKey": null,
      "args": null,
      "concreteType": "StaffNode",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "fullName",
          "args": null,
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "organization",
          "storageKey": null,
          "args": null,
          "concreteType": "OrgNode",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "country",
              "storageKey": null,
              "args": null,
              "concreteType": "Country",
              "plural": false,
              "selections": [
                (v1/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e7983cd95429585bb421c1b488a0701c';
module.exports = node;
